import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export enum InclusivityMode {
  Include = "INCLUDE",
  Exclude = "EXCLUDE"
}

export type Job = {
  __typename?: "Job";
  number: Scalars["String"];
  description: Scalars["String"];
  personResponsible?: Maybe<Resource>;
  inventory?: Maybe<Scalars["Float"]>;
  deadQuantity?: Maybe<Scalars["Float"]>;
  startDate?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["String"]>;
  groupStartDate?: Maybe<Scalars["String"]>;
  location: Location;
  projectManager?: Maybe<User>;
  status?: Maybe<Scalars["String"]>;
  startQuantity: Scalars["Float"];
  postingGroup?: Maybe<Scalars["String"]>;
  healthStatus?: Maybe<HealthStatus>;
};

export type JobCard = {
  __typename?: "JobCard";
  number: Scalars["String"];
  description: Scalars["String"];
  personResponsible?: Maybe<Resource>;
  inventory?: Maybe<Scalars["Float"]>;
  deadQuantity?: Maybe<Scalars["Float"]>;
  startDate?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["String"]>;
  groupStartDate?: Maybe<Scalars["String"]>;
  location: Location;
  projectManager?: Maybe<User>;
  status?: Maybe<Scalars["String"]>;
  healthStatus?: Maybe<Scalars["String"]>;
  pigSourceFlow?: Maybe<Scalars["String"]>;
  nutrition?: Maybe<Scalars["String"]>;
  feedmill?: Maybe<Scalars["String"]>;
};

export type Item = {
  __typename?: "Item";
  number: Scalars["String"];
  description: Scalars["String"];
  type?: Maybe<Scalars["String"]>;
  cost?: Maybe<Scalars["Float"]>;
  unit?: Maybe<Scalars["String"]>;
};

export type Reason = {
  __typename?: "Reason";
  code: Scalars["String"];
  description: Scalars["String"];
};

export type Resource = {
  __typename?: "Resource";
  number: Scalars["String"];
  name: Scalars["String"];
  unitPrice?: Maybe<Scalars["Float"]>;
};

export type Location = {
  __typename?: "Location";
  code: Scalars["String"];
  name: Scalars["String"];
};

export type JobFilter = {
  groups?: Maybe<Array<Scalars["String"]>>;
  locations?: Maybe<Array<Scalars["String"]>>;
};

export type ResourceFilter = {
  group?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

export type JobJournalTemplate = {
  __typename?: "JobJournalTemplate";
  name: Scalars["String"];
  description: Scalars["String"];
  sourceCode: Scalars["String"];
  reasonCode: Scalars["String"];
};

export type JobPostingGroup = {
  __typename?: "JobPostingGroup";
  code: Scalars["String"];
  description: Scalars["String"];
};

export type KeyValuePair = {
  __typename?: "KeyValuePair";
  code?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
};

export type Query = {
  __typename?: "Query";
  animals: Array<Item>;
  dimensionPackers: Array<DimensionPacker>;
  feedmill: Array<KeyValuePair>;
  fuelAsset?: Maybe<FuelAsset>;
  fuelAssets: Array<FuelAsset>;
  fuelHistoryAsset: Array<FuelHistoryAsset>;
  healthStatus: Array<HealthStatus>;
  item?: Maybe<Item>;
  itemJournalTemplates?: Maybe<Array<ItemJournalTemplate>>;
  items: Array<ItemConsumption>;
  job?: Maybe<Job>;
  jobCard?: Maybe<JobCard>;
  jobCards: Array<JobCard>;
  jobJournalTemplate?: Maybe<JobJournalTemplate>;
  jobJournalTemplates?: Maybe<Array<JobJournalTemplate>>;
  jobPostingGroups: Array<JobPostingGroup>;
  jobs: Array<Job>;
  livestockActivityDefaults: LivestockActivityDefaults;
  livestockActivityJobs: Array<Job>;
  livestockAdjustment: LivestockAdjustment;
  livestockAdjustmentEventTypes: Array<LivestockAdjustmentEvent>;
  livestockGradeOff: LivestockGradeOff;
  livestockGradeOffEventTypes: Array<LivestockGradeOffEvent>;
  livestockJob?: Maybe<Job>;
  livestockJobs: Array<Job>;
  livestockMortality: LivestockMortality;
  livestockMortalityEventType: LivestockMortalityEvent;
  livestockMove: LivestockMove;
  livestockMoveEventTypes: Array<LivestockMoveEvent>;
  livestockPurchase: LivestockPurchase;
  livestockPurchaseEventTypes: Array<LivestockPurchaseEvent>;
  livestockShipment: LivestockShipment;
  livestockShipmentEventTypes: Array<LivestockShipmentEvent>;
  livestockWean: LivestockWean;
  livestockWeanEventTypes: Array<LivestockWeanEvent>;
  locations: Array<Location>;
  maintenanceAsset?: Maybe<MaintenanceAsset>;
  maintenanceAssets: Array<MaintenanceAsset>;
  maintenanceAssetsByNo: Array<MaintenanceAsset>;
  maintenanceHistoryAsset: Array<MaintenanceHistoryAsset>;
  menuOptions: Array<MenuOption>;
  nutrition: Array<KeyValuePair>;
  pigSourceFlow: Array<KeyValuePair>;
  resource?: Maybe<Resource>;
  resources: Array<Resource>;
  scorecard?: Maybe<Scorecard>;
  scorecardConfig?: Maybe<ScorecardConfig>;
  scorecardTypes?: Maybe<Array<ScorecardType>>;
  user?: Maybe<User>;
  users: Array<User>;
};

export type QueryFuelAssetArgs = {
  number: Scalars["String"];
};

export type QueryFuelHistoryAssetArgs = {
  number: Scalars["String"];
};

export type QueryItemArgs = {
  number: Scalars["String"];
};

export type QueryItemsArgs = {
  location: Scalars["String"];
};

export type QueryJobArgs = {
  number: Scalars["String"];
};

export type QueryJobCardArgs = {
  number: Scalars["String"];
};

export type QueryJobJournalTemplateArgs = {
  name: Scalars["String"];
};

export type QueryJobsArgs = {
  input?: Maybe<JobFilter>;
};

export type QueryLivestockActivityJobsArgs = {
  isShipment?: Maybe<Scalars["Boolean"]>;
};

export type QueryLivestockAdjustmentArgs = {
  job: Scalars["String"];
};

export type QueryLivestockGradeOffArgs = {
  job: Scalars["String"];
};

export type QueryLivestockJobArgs = {
  number: Scalars["String"];
};

export type QueryLivestockJobsArgs = {
  input?: Maybe<JobFilter>;
};

export type QueryLivestockMortalityArgs = {
  job: Scalars["String"];
};

export type QueryLivestockMortalityEventTypeArgs = {
  job: Scalars["String"];
};

export type QueryLivestockMoveArgs = {
  job: Scalars["String"];
};

export type QueryLivestockPurchaseArgs = {
  job: Scalars["String"];
};

export type QueryLivestockShipmentArgs = {
  job: Scalars["String"];
};

export type QueryLivestockWeanArgs = {
  job: Scalars["String"];
};

export type QueryMaintenanceAssetArgs = {
  number: Scalars["String"];
};

export type QueryMaintenanceAssetsByNoArgs = {
  assetNo: Scalars["String"];
};

export type QueryMaintenanceHistoryAssetArgs = {
  number: Scalars["String"];
};

export type QueryResourceArgs = {
  code: Scalars["String"];
};

export type QueryResourcesArgs = {
  input?: Maybe<ResourceFilter>;
};

export type QueryScorecardArgs = {
  job: Scalars["String"];
};

export type QueryScorecardConfigArgs = {
  job: Scalars["String"];
  postingGroup: Scalars["String"];
};

export type QueryScorecardTypesArgs = {
  number: Scalars["String"];
};

export type FuelAsset = {
  __typename?: "FuelAsset";
  number: Scalars["String"];
  code: Scalars["String"];
  description: Scalars["String"];
  fuelType: Scalars["String"];
  fuelCost: Scalars["Float"];
  unitOfMeasureCode: Scalars["String"];
};

export type FuelHistoryAsset = {
  __typename?: "FuelHistoryAsset";
  entry: Scalars["Int"];
  number: Scalars["String"];
  amount: Scalars["Float"];
  maintenanceCode: Scalars["String"];
  reasonCode: Scalars["String"];
  postingDate: Scalars["String"];
  quantity: Scalars["Float"];
  description: Scalars["String"];
  meta: Scalars["Float"];
};

export type PostFuelInput = {
  asset: Scalars["String"];
  postingDate?: Maybe<Scalars["String"]>;
  gallons: Scalars["Float"];
  mileage: Scalars["Float"];
  comments?: Maybe<Scalars["String"]>;
};

export type FuelResult = {
  __typename?: "FuelResult";
  success: Scalars["Boolean"];
};

export type Mutation = {
  __typename?: "Mutation";
  autoPostFuelMaintenance: FuelResult;
  autoPostInventory: AutoPostResult;
  autoPostItemJournal?: Maybe<AutoPostResult>;
  autoPostScorecards: AutoPostResult;
  login: LoginResult;
  logout: LogoutResult;
  postFuel: FuelResult;
  postInventory: InventoryResult;
  postLivestockAdjustment: LivestockAdjustmentResult;
  postLivestockGradeOff: LivestockGradeOffResult;
  postLivestockMortality: LivestockMortalityResult;
  postLivestockMove: LivestockMoveResult;
  postLivestockPurchase: LivestockPurchaseResult;
  postLivestockShipment: LivestockShipmentResult;
  postLivestockWean: LivestockWeanResult;
  postMaintenance: MaintenanceResult;
  postScorecard: ScorecardResult;
  saveLivestockAdjustment: LivestockAdjustmentResult;
  saveLivestockGradeOff: LivestockGradeOffResult;
  saveLivestockMortality: LivestockMortalityResult;
  saveLivestockMove: LivestockMoveResult;
  saveLivestockPurchase: LivestockPurchaseResult;
  saveLivestockShipment: LivestockShipmentResult;
  saveLivestockWean: LivestockWeanResult;
  saveScorecard: ScorecardResult;
  updateHealthStatus?: Maybe<HealthStatusResult>;
  updateJob: UpdateJobResult;
  updateUserLocations: UpdateUserLocationsResult;
  updateUserMenuOptions: UpdateUserMenuOptionsResult;
  updateUserPostingGroups: UpdateUserPostingGroupsResult;
};

export type MutationAutoPostItemJournalArgs = {
  input: AutoPostInput;
};

export type MutationAutoPostScorecardsArgs = {
  input?: Maybe<ScorecardAutoPostInput>;
};

export type MutationLoginArgs = {
  input: LoginInput;
};

export type MutationPostFuelArgs = {
  input: PostFuelInput;
};

export type MutationPostInventoryArgs = {
  input: PostInventoryInput;
};

export type MutationPostLivestockAdjustmentArgs = {
  input: PostLivestockAdjustmentInput;
};

export type MutationPostLivestockGradeOffArgs = {
  input: PostLivestockGradeOffInput;
};

export type MutationPostLivestockMortalityArgs = {
  input: PostLivestockMortalityInput;
};

export type MutationPostLivestockMoveArgs = {
  input: PostLivestockMoveInput;
};

export type MutationPostLivestockPurchaseArgs = {
  input: PostLivestockPurchaseInput;
};

export type MutationPostLivestockShipmentArgs = {
  input: PostLivestockShipmentInput;
};

export type MutationPostLivestockWeanArgs = {
  input: PostLivestockWeanInput;
};

export type MutationPostMaintenanceArgs = {
  input: PostMaintenanceInput;
};

export type MutationPostScorecardArgs = {
  input: PostScorecardInput;
};

export type MutationSaveLivestockAdjustmentArgs = {
  input: SaveLivestockAdjustmentInput;
};

export type MutationSaveLivestockGradeOffArgs = {
  input: SaveLivestockGradeOffInput;
};

export type MutationSaveLivestockMortalityArgs = {
  input: SaveLivestockMortalityInput;
};

export type MutationSaveLivestockMoveArgs = {
  input: SaveLivestockMoveInput;
};

export type MutationSaveLivestockPurchaseArgs = {
  input: SaveLivestockPurchaseInput;
};

export type MutationSaveLivestockShipmentArgs = {
  input: SaveLivestockShipmentInput;
};

export type MutationSaveLivestockWeanArgs = {
  input: SaveLivestockWeanInput;
};

export type MutationSaveScorecardArgs = {
  input: PostScorecardInput;
};

export type MutationUpdateHealthStatusArgs = {
  input: UpdateHealthStatusInput;
};

export type MutationUpdateJobArgs = {
  input: UpdateJobInput;
};

export type MutationUpdateUserLocationsArgs = {
  input: UpdateUserLocationsInput;
};

export type MutationUpdateUserMenuOptionsArgs = {
  input: UpdateUserMenuOptionsInput;
};

export type MutationUpdateUserPostingGroupsArgs = {
  input: UpdateUserPostingGroupsInput;
};

export type Inventory = {
  __typename?: "Inventory";
  location: Scalars["String"];
  group: Scalars["String"];
  postingDate?: Maybe<Scalars["String"]>;
  item?: Maybe<Scalars["String"]>;
  quantity?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type ItemConsumption = {
  __typename?: "ItemConsumption";
  number: Scalars["String"];
  location?: Maybe<Scalars["String"]>;
  balance: Scalars["Float"];
  description?: Maybe<Scalars["String"]>;
  cost: Scalars["Float"];
  unit?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

export type ItemList = {
  __typename?: "ItemList";
  item: Item;
  quantity: Scalars["Float"];
};

export type ItemInput = {
  number: Scalars["String"];
  description: Scalars["String"];
  type: Scalars["String"];
  cost: Scalars["Float"];
  unit?: Maybe<Scalars["String"]>;
};

export type ItemListInput = {
  item: ItemInput;
  quantity: Scalars["Float"];
  acres?: Maybe<Scalars["Float"]>;
};

export type PostInventoryInput = {
  location: Scalars["String"];
  group: Scalars["String"];
  postingDate?: Maybe<Scalars["String"]>;
  itemList?: Maybe<Array<ItemListInput>>;
  comments?: Maybe<Scalars["String"]>;
};

export type InventoryResult = {
  __typename?: "InventoryResult";
  success: Scalars["Boolean"];
  defaults: LivestockActivityDefaults;
};

export type LivestockActivityDefaults = {
  __typename?: "LivestockActivityDefaults";
  job?: Maybe<Job>;
  location?: Maybe<Location>;
  prices: Array<PriceEntry>;
};

export type LivestockWeanEvent = {
  __typename?: "LivestockWeanEvent";
  code: Scalars["String"];
  description: Scalars["String"];
};

export type LivestockGradeOffEvent = {
  __typename?: "LivestockGradeOffEvent";
  code: Scalars["String"];
  description: Scalars["String"];
  reasons: Array<Reason>;
};

export type LivestockMoveEvent = {
  __typename?: "LivestockMoveEvent";
  code: Scalars["String"];
  description: Scalars["String"];
};

export type LivestockPurchaseEvent = {
  __typename?: "LivestockPurchaseEvent";
  code: Scalars["String"];
  description: Scalars["String"];
};

export type LivestockAdjustmentEvent = {
  __typename?: "LivestockAdjustmentEvent";
  code: Scalars["String"];
  description: Scalars["String"];
};

export type LivestockMortalityEvent = {
  __typename?: "LivestockMortalityEvent";
  code: Scalars["String"];
  description: Scalars["String"];
  reasons: Array<Reason>;
};

export type LivestockShipmentEvent = {
  __typename?: "LivestockShipmentEvent";
  code: Scalars["String"];
  description: Scalars["String"];
};

export type PriceEntry = {
  __typename?: "PriceEntry";
  animal: Scalars["String"];
  price?: Maybe<Scalars["Float"]>;
};

export type LivestockQuantity = {
  __typename?: "LivestockQuantity";
  code: Scalars["String"];
  quantity?: Maybe<Scalars["Int"]>;
};

export type LivestockQuantityInput = {
  code: Scalars["String"];
  quantity: Scalars["Int"];
};

export type LivestockOptionalQuantityInput = {
  code: Scalars["String"];
  quantity?: Maybe<Scalars["Int"]>;
};

export type LivestockAdjustment = {
  __typename?: "LivestockAdjustment";
  event?: Maybe<LivestockAdjustmentEvent>;
  postingDate?: Maybe<Scalars["String"]>;
  job: Job;
  quantity?: Maybe<Scalars["Int"]>;
  totalWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type PostLivestockAdjustmentInput = {
  event: Scalars["String"];
  postingDate: Scalars["String"];
  job: Scalars["String"];
  quantity: Scalars["Int"];
  totalWeight: Scalars["Float"];
  comments?: Maybe<Scalars["String"]>;
};

export type SaveLivestockAdjustmentInput = {
  event: Scalars["String"];
  postingDate?: Maybe<Scalars["String"]>;
  job: Scalars["String"];
  quantity?: Maybe<Scalars["Int"]>;
  totalWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type LivestockAdjustmentResult = {
  __typename?: "LivestockAdjustmentResult";
  success: Scalars["Boolean"];
  livestockAdjustment: LivestockAdjustment;
  defaults: LivestockActivityDefaults;
};

export type LivestockGradeOff = {
  __typename?: "LivestockGradeOff";
  event?: Maybe<LivestockGradeOffEvent>;
  postingDate?: Maybe<Scalars["String"]>;
  job: Job;
  quantities: Array<LivestockQuantity>;
  livestockWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type PostLivestockGradeOffInput = {
  event: Scalars["String"];
  postingDate: Scalars["String"];
  job: Scalars["String"];
  quantities: Array<LivestockQuantityInput>;
  livestockWeight: Scalars["Float"];
  comments?: Maybe<Scalars["String"]>;
};

export type SaveLivestockGradeOffInput = {
  event?: Maybe<Scalars["String"]>;
  postingDate?: Maybe<Scalars["String"]>;
  job: Scalars["String"];
  quantities?: Maybe<Array<LivestockOptionalQuantityInput>>;
  livestockWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type LivestockGradeOffResult = {
  __typename?: "LivestockGradeOffResult";
  success: Scalars["Boolean"];
  livestockGradeOff: LivestockGradeOff;
  defaults: LivestockActivityDefaults;
};

export type LivestockMortality = {
  __typename?: "LivestockMortality";
  event?: Maybe<LivestockMortalityEvent>;
  postingDate?: Maybe<Scalars["String"]>;
  job: Job;
  quantities?: Maybe<Array<LivestockQuantity>>;
  comments?: Maybe<Scalars["String"]>;
  reasons?: Maybe<Array<Reason>>;
};

export type PostLivestockMortalityInput = {
  postingDate?: Maybe<Scalars["String"]>;
  job: Scalars["String"];
  quantities?: Maybe<Array<LivestockQuantityInput>>;
  comments?: Maybe<Scalars["String"]>;
};

export type SaveLivestockMortalityInput = {
  postingDate?: Maybe<Scalars["String"]>;
  job: Scalars["String"];
  quantities?: Maybe<Array<LivestockOptionalQuantityInput>>;
  comments?: Maybe<Scalars["String"]>;
};

export type LivestockMortalityResult = {
  __typename?: "LivestockMortalityResult";
  success: Scalars["Boolean"];
  livestockMortality: LivestockMortality;
  defaults: LivestockActivityDefaults;
};

export type LivestockMove = {
  __typename?: "LivestockMove";
  event?: Maybe<LivestockMoveEvent>;
  postingDate?: Maybe<Scalars["String"]>;
  fromJob: Job;
  toJob?: Maybe<Job>;
  quantity?: Maybe<Scalars["Int"]>;
  smallLivestockQuantity?: Maybe<Scalars["Int"]>;
  totalWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type PostLivestockMoveInput = {
  event: Scalars["String"];
  postingDate: Scalars["String"];
  fromJob: Scalars["String"];
  toJob: Scalars["String"];
  quantity: Scalars["Int"];
  smallLivestockQuantity?: Maybe<Scalars["Int"]>;
  totalWeight: Scalars["Float"];
  comments?: Maybe<Scalars["String"]>;
};

export type SaveLivestockMoveInput = {
  event?: Maybe<Scalars["String"]>;
  postingDate?: Maybe<Scalars["String"]>;
  fromJob: Scalars["String"];
  toJob?: Maybe<Scalars["String"]>;
  quantity?: Maybe<Scalars["Int"]>;
  smallLivestockQuantity?: Maybe<Scalars["Int"]>;
  totalWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type LivestockMoveResult = {
  __typename?: "LivestockMoveResult";
  success: Scalars["Boolean"];
  livestockMove: LivestockMove;
  defaults: LivestockActivityDefaults;
};

export type LivestockPurchase = {
  __typename?: "LivestockPurchase";
  event?: Maybe<LivestockPurchaseEvent>;
  postingDate?: Maybe<Scalars["String"]>;
  job: Job;
  quantity?: Maybe<Scalars["Int"]>;
  smallLivestockQuantity?: Maybe<Scalars["Int"]>;
  totalWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type PostLivestockPurchaseInput = {
  event: Scalars["String"];
  postingDate: Scalars["String"];
  job: Scalars["String"];
  quantity: Scalars["Int"];
  smallLivestockQuantity?: Maybe<Scalars["Int"]>;
  totalWeight: Scalars["Float"];
  comments?: Maybe<Scalars["String"]>;
};

export type SaveLivestockPurchaseInput = {
  event: Scalars["String"];
  postingDate?: Maybe<Scalars["String"]>;
  job: Scalars["String"];
  quantity?: Maybe<Scalars["Int"]>;
  smallLivestockQuantity?: Maybe<Scalars["Int"]>;
  totalWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type LivestockPurchaseResult = {
  __typename?: "LivestockPurchaseResult";
  success: Scalars["Boolean"];
  livestockPurchase: LivestockPurchase;
  defaults: LivestockActivityDefaults;
};

export type LivestockWean = {
  __typename?: "LivestockWean";
  event?: Maybe<LivestockWeanEvent>;
  postingDate?: Maybe<Scalars["String"]>;
  job: Job;
  quantity?: Maybe<Scalars["Int"]>;
  smallLivestockQuantity?: Maybe<Scalars["Int"]>;
  totalWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type PostLivestockWeanInput = {
  event: Scalars["String"];
  postingDate: Scalars["String"];
  job: Scalars["String"];
  quantity: Scalars["Int"];
  smallLivestockQuantity?: Maybe<Scalars["Int"]>;
  totalWeight: Scalars["Float"];
  comments?: Maybe<Scalars["String"]>;
};

export type SaveLivestockWeanInput = {
  event?: Maybe<Scalars["String"]>;
  postingDate?: Maybe<Scalars["String"]>;
  job: Scalars["String"];
  quantity?: Maybe<Scalars["Int"]>;
  smallLivestockQuantity?: Maybe<Scalars["Int"]>;
  totalWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type LivestockWeanResult = {
  __typename?: "LivestockWeanResult";
  success: Scalars["Boolean"];
  livestockWean: LivestockWean;
  defaults: LivestockActivityDefaults;
};

export type LivestockShipment = {
  __typename?: "LivestockShipment";
  event?: Maybe<LivestockShipmentEvent>;
  dimensionPacker?: Maybe<Scalars["String"]>;
  postingDate?: Maybe<Scalars["String"]>;
  job: Job;
  quantity?: Maybe<Scalars["Int"]>;
  deadsOnArrivalQuantity?: Maybe<Scalars["Int"]>;
  totalWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type PostLivestockShipmentInput = {
  event: Scalars["String"];
  dimensionPacker: Scalars["String"];
  postingDate: Scalars["String"];
  job: Scalars["String"];
  quantity: Scalars["Int"];
  deadsOnArrivalQuantity?: Maybe<Scalars["Int"]>;
  totalWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type SaveLivestockShipmentInput = {
  event?: Maybe<Scalars["String"]>;
  dimensionPacker?: Maybe<Scalars["String"]>;
  postingDate?: Maybe<Scalars["String"]>;
  job: Scalars["String"];
  quantity?: Maybe<Scalars["Int"]>;
  deadsOnArrivalQuantity?: Maybe<Scalars["Int"]>;
  totalWeight?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type LivestockShipmentResult = {
  __typename?: "LivestockShipmentResult";
  success: Scalars["Boolean"];
  livestockShipment: LivestockShipment;
  defaults: LivestockActivityDefaults;
};

export type ItemJournalTemplate = {
  __typename?: "ItemJournalTemplate";
  name: Scalars["String"];
  description: Scalars["String"];
  type: Scalars["String"];
  sourceCode: Scalars["String"];
  reasonCode: Scalars["String"];
};

export type DimensionPacker = {
  __typename?: "DimensionPacker";
  code: Scalars["String"];
  dimensionCode: Scalars["String"];
  dimensionName: Scalars["String"];
};

export type AutoPostInput = {
  itemJournalTemplate: Scalars["String"];
};

export type AutoPostResult = {
  __typename?: "AutoPostResult";
  success: Scalars["Boolean"];
};

export type HealthStatus = {
  __typename?: "HealthStatus";
  code?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  color?: Maybe<Scalars["String"]>;
};

export type UpdateHealthStatusInput = {
  group: Scalars["String"];
  healthStatus: Scalars["String"];
};

export type HealthStatusResult = {
  __typename?: "HealthStatusResult";
  success: Scalars["Boolean"];
};

export type MaintenanceAsset = {
  __typename?: "MaintenanceAsset";
  number: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  classCode?: Maybe<Scalars["String"]>;
  code: Scalars["String"];
  interval?: Maybe<Scalars["Int"]>;
  unitType?: Maybe<Scalars["String"]>;
  maintenanceDesc?: Maybe<Scalars["String"]>;
};

export type MaintenanceHistoryAsset = {
  __typename?: "MaintenanceHistoryAsset";
  entry: Scalars["Int"];
  number: Scalars["String"];
  amount: Scalars["Float"];
  maintenanceCode: Scalars["String"];
  reasonCode: Scalars["String"];
  postingDate: Scalars["String"];
  quantity: Scalars["Float"];
  description: Scalars["String"];
  meta: Scalars["Float"];
  codeDescription: Scalars["String"];
  payToName: Scalars["String"];
  documentNo: Scalars["String"];
};

export type PostMaintenanceInput = {
  asset: Scalars["String"];
  postingDate?: Maybe<Scalars["String"]>;
  type: Scalars["String"];
  mileage?: Maybe<Scalars["Float"]>;
  workHours: Scalars["Float"];
  totalCost?: Maybe<Scalars["Float"]>;
  comments?: Maybe<Scalars["String"]>;
};

export type MaintenanceResult = {
  __typename?: "MaintenanceResult";
  success: Scalars["Boolean"];
};

export type ScorecardType = {
  __typename?: "ScorecardType";
  code: Scalars["String"];
  description: Scalars["String"];
};

export type ScorecardElement = {
  __typename?: "ScorecardElement";
  id: Scalars["ID"];
  label: Scalars["String"];
  code: Scalars["String"];
  order: Scalars["Int"];
  max: Scalars["Int"];
};

export type ScorecardPage = {
  __typename?: "ScorecardPage";
  title?: Maybe<Scalars["String"]>;
  elements: Array<ScorecardElement>;
};

export type ScorecardConfig = {
  __typename?: "ScorecardConfig";
  job: Job;
  postingGroup: Scalars["String"];
  pages: Array<ScorecardPage>;
};

export type ScorecardElementResponseInput = {
  elementId: Scalars["ID"];
  numericValue?: Maybe<Scalars["Float"]>;
  stringValue?: Maybe<Scalars["String"]>;
};

export type PostScorecardInput = {
  job: Scalars["String"];
  postingGroup: Scalars["String"];
  data: Array<ScorecardElementResponseInput>;
};

export type ScorecardResult = {
  __typename?: "ScorecardResult";
  success: Scalars["Boolean"];
  scorecard?: Maybe<Scorecard>;
};

export type ScorecardElementResponse = {
  __typename?: "ScorecardElementResponse";
  elementId: Scalars["ID"];
  numericValue?: Maybe<Scalars["Float"]>;
  stringValue?: Maybe<Scalars["String"]>;
};

export type Scorecard = {
  __typename?: "Scorecard";
  job: Job;
  data: Array<ScorecardElementResponse>;
};

export type ScorecardAutoPostInput = {
  postingGroup: Scalars["String"];
  job: Scalars["String"];
};

export type ScorecardConfigInput = {
  job: Scalars["String"];
  postingGroup: Scalars["String"];
};

export type UserLocations = {
  __typename?: "UserLocations";
  mode: InclusivityMode;
  list: Array<Location>;
};

export type MenuOption = {
  __typename?: "MenuOption";
  name: Scalars["String"];
  route: Scalars["String"];
};

export type UserMenuOptions = {
  __typename?: "UserMenuOptions";
  mode: InclusivityMode;
  list: Array<MenuOption>;
};

export type UserPostingGroups = {
  __typename?: "UserPostingGroups";
  mode: InclusivityMode;
  list: Array<JobPostingGroup>;
};

export type User = {
  __typename?: "User";
  username: Scalars["String"];
  license: Scalars["String"];
  name: Scalars["String"];
  locations: UserLocations;
  menuOptions: UserMenuOptions;
  postingGroups: UserPostingGroups;
};

export type LoginInput = {
  username: Scalars["String"];
  password: Scalars["String"];
};

export type LoginResult = {
  __typename?: "LoginResult";
  success: Scalars["Boolean"];
  user: User;
};

export type LogoutResult = {
  __typename?: "LogoutResult";
  success: Scalars["Boolean"];
};

export type UpdateUserLocationsInput = {
  add?: Maybe<Array<Scalars["String"]>>;
  remove?: Maybe<Array<Scalars["String"]>>;
  mode?: Maybe<InclusivityMode>;
};

export type UpdateUserMenuOptionsInput = {
  add?: Maybe<Array<Scalars["String"]>>;
  remove?: Maybe<Array<Scalars["String"]>>;
  mode?: Maybe<InclusivityMode>;
};

export type UpdateUserPostingGroupsInput = {
  add?: Maybe<Array<Scalars["String"]>>;
  remove?: Maybe<Array<Scalars["String"]>>;
  mode?: Maybe<InclusivityMode>;
};

export type UpdateJobInput = {
  status?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["String"]>;
  group?: Maybe<Scalars["String"]>;
  desc?: Maybe<Scalars["String"]>;
  healthStatus?: Maybe<Scalars["String"]>;
  pigSourceFlow?: Maybe<Scalars["String"]>;
  feedmill?: Maybe<Scalars["String"]>;
  nutrition?: Maybe<Scalars["String"]>;
  person?: Maybe<Scalars["String"]>;
  supervisor?: Maybe<Scalars["String"]>;
};

export type UpdateUserLocationsResult = {
  __typename?: "UpdateUserLocationsResult";
  success: Scalars["Boolean"];
  locations: UserLocations;
};

export type UpdateUserMenuOptionsResult = {
  __typename?: "UpdateUserMenuOptionsResult";
  success: Scalars["Boolean"];
  menuOptions: UserMenuOptions;
};

export type UpdateUserPostingGroupsResult = {
  __typename?: "UpdateUserPostingGroupsResult";
  success: Scalars["Boolean"];
  postingGroups: UserPostingGroups;
};

export type UpdateJobResult = {
  __typename?: "UpdateJobResult";
  success: Scalars["Boolean"];
  job?: Maybe<JobCard>;
};

export type MaintenanceAssetsQueryVariables = {};

export type MaintenanceAssetsQuery = { __typename?: "Query" } & {
  maintenanceAssets: Array<
    { __typename?: "MaintenanceAsset" } & Pick<
      MaintenanceAsset,
      "number" | "description"
    >
  >;
};

export type MaintenanceAssetQueryVariables = {
  number: Scalars["String"];
};

export type MaintenanceAssetQuery = { __typename?: "Query" } & {
  maintenanceAsset?: Maybe<
    { __typename?: "MaintenanceAsset" } & Pick<
      MaintenanceAsset,
      "number" | "description"
    >
  >;
  maintenanceAssetsByNo: Array<
    { __typename?: "MaintenanceAsset" } & Pick<
      MaintenanceAsset,
      "code" | "interval" | "unitType" | "maintenanceDesc"
    >
  >;
  item?: Maybe<{ __typename?: "Item" } & Pick<Item, "number" | "cost">>;
};

export type MaintenanceHistoryAssetQueryVariables = {
  number: Scalars["String"];
};

export type MaintenanceHistoryAssetQuery = { __typename?: "Query" } & {
  maintenanceHistoryAsset: Array<
    { __typename?: "MaintenanceHistoryAsset" } & Pick<
      MaintenanceHistoryAsset,
      | "entry"
      | "number"
      | "amount"
      | "maintenanceCode"
      | "reasonCode"
      | "postingDate"
      | "quantity"
      | "meta"
      | "description"
      | "codeDescription"
      | "payToName"
      | "documentNo"
    >
  >;
};

export type PostMaintenanceMutationVariables = {
  input: PostMaintenanceInput;
};

export type PostMaintenanceMutation = { __typename?: "Mutation" } & {
  postMaintenance: { __typename?: "MaintenanceResult" } & Pick<
    MaintenanceResult,
    "success"
  >;
};

export const MaintenanceAssetsDocument = gql`
  query MaintenanceAssets {
    maintenanceAssets {
      number
      description
    }
  }
`;

/**
 * __useMaintenanceAssetsQuery__
 *
 * To run a query within a React component, call `useMaintenanceAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaintenanceAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaintenanceAssetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaintenanceAssetsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MaintenanceAssetsQuery,
    MaintenanceAssetsQueryVariables
  >
) {
  return Apollo.useQuery<
    MaintenanceAssetsQuery,
    MaintenanceAssetsQueryVariables
  >(MaintenanceAssetsDocument, baseOptions);
}
export function useMaintenanceAssetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MaintenanceAssetsQuery,
    MaintenanceAssetsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    MaintenanceAssetsQuery,
    MaintenanceAssetsQueryVariables
  >(MaintenanceAssetsDocument, baseOptions);
}
export type MaintenanceAssetsQueryHookResult = ReturnType<
  typeof useMaintenanceAssetsQuery
>;
export type MaintenanceAssetsLazyQueryHookResult = ReturnType<
  typeof useMaintenanceAssetsLazyQuery
>;
export type MaintenanceAssetsQueryResult = Apollo.QueryResult<
  MaintenanceAssetsQuery,
  MaintenanceAssetsQueryVariables
>;
export const MaintenanceAssetDocument = gql`
  query MaintenanceAsset($number: String!) {
    maintenanceAsset(number: $number) {
      number
      description
    }
    maintenanceAssetsByNo(assetNo: $number) {
      code
      interval
      unitType
      maintenanceDesc
    }
    item(number: "LABOR") {
      number
      cost
    }
  }
`;

/**
 * __useMaintenanceAssetQuery__
 *
 * To run a query within a React component, call `useMaintenanceAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaintenanceAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaintenanceAssetQuery({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
export function useMaintenanceAssetQuery(
  baseOptions: Apollo.QueryHookOptions<
    MaintenanceAssetQuery,
    MaintenanceAssetQueryVariables
  >
) {
  return Apollo.useQuery<MaintenanceAssetQuery, MaintenanceAssetQueryVariables>(
    MaintenanceAssetDocument,
    baseOptions
  );
}
export function useMaintenanceAssetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MaintenanceAssetQuery,
    MaintenanceAssetQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    MaintenanceAssetQuery,
    MaintenanceAssetQueryVariables
  >(MaintenanceAssetDocument, baseOptions);
}
export type MaintenanceAssetQueryHookResult = ReturnType<
  typeof useMaintenanceAssetQuery
>;
export type MaintenanceAssetLazyQueryHookResult = ReturnType<
  typeof useMaintenanceAssetLazyQuery
>;
export type MaintenanceAssetQueryResult = Apollo.QueryResult<
  MaintenanceAssetQuery,
  MaintenanceAssetQueryVariables
>;
export const MaintenanceHistoryAssetDocument = gql`
  query MaintenanceHistoryAsset($number: String!) {
    maintenanceHistoryAsset(number: $number) {
      entry
      number
      amount
      maintenanceCode
      reasonCode
      postingDate
      quantity
      meta
      description
      codeDescription
      payToName
      documentNo
    }
  }
`;

/**
 * __useMaintenanceHistoryAssetQuery__
 *
 * To run a query within a React component, call `useMaintenanceHistoryAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaintenanceHistoryAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaintenanceHistoryAssetQuery({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
export function useMaintenanceHistoryAssetQuery(
  baseOptions: Apollo.QueryHookOptions<
    MaintenanceHistoryAssetQuery,
    MaintenanceHistoryAssetQueryVariables
  >
) {
  return Apollo.useQuery<
    MaintenanceHistoryAssetQuery,
    MaintenanceHistoryAssetQueryVariables
  >(MaintenanceHistoryAssetDocument, baseOptions);
}
export function useMaintenanceHistoryAssetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MaintenanceHistoryAssetQuery,
    MaintenanceHistoryAssetQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    MaintenanceHistoryAssetQuery,
    MaintenanceHistoryAssetQueryVariables
  >(MaintenanceHistoryAssetDocument, baseOptions);
}
export type MaintenanceHistoryAssetQueryHookResult = ReturnType<
  typeof useMaintenanceHistoryAssetQuery
>;
export type MaintenanceHistoryAssetLazyQueryHookResult = ReturnType<
  typeof useMaintenanceHistoryAssetLazyQuery
>;
export type MaintenanceHistoryAssetQueryResult = Apollo.QueryResult<
  MaintenanceHistoryAssetQuery,
  MaintenanceHistoryAssetQueryVariables
>;
export const PostMaintenanceDocument = gql`
  mutation PostMaintenance($input: PostMaintenanceInput!) {
    postMaintenance(input: $input) {
      success
    }
  }
`;
export type PostMaintenanceMutationFn = Apollo.MutationFunction<
  PostMaintenanceMutation,
  PostMaintenanceMutationVariables
>;

/**
 * __usePostMaintenanceMutation__
 *
 * To run a mutation, you first call `usePostMaintenanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostMaintenanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postMaintenanceMutation, { data, loading, error }] = usePostMaintenanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostMaintenanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PostMaintenanceMutation,
    PostMaintenanceMutationVariables
  >
) {
  return Apollo.useMutation<
    PostMaintenanceMutation,
    PostMaintenanceMutationVariables
  >(PostMaintenanceDocument, baseOptions);
}
export type PostMaintenanceMutationHookResult = ReturnType<
  typeof usePostMaintenanceMutation
>;
export type PostMaintenanceMutationResult = Apollo.MutationResult<
  PostMaintenanceMutation
>;
export type PostMaintenanceMutationOptions = Apollo.BaseMutationOptions<
  PostMaintenanceMutation,
  PostMaintenanceMutationVariables
>;
